import React, { useContext } from 'react';
import classNames from 'classnames';
import { translate } from '@fiverr-private/i18n-react';
import { useImpressionItem } from '@fiverr-private/impressionable';
import { lime_700 } from '@fiverr-private/sass/helpers';
import { Video } from '@fiverr-private/orca';
import { Grid, Col, Section } from '@fiverr-private/fit';
import { CategoriesIcon, ClockIcon, LockIcon } from '@fiverr-private/icons';
import { getContext } from '@fiverr-private/fiverr_context';
import { reportFooterShown, reportFooterPlayed } from '../../utils/report/bigquery';
import AppContext from '../../state/AppContext';
import { getLocalizedHowFiverrWorksVideo } from './utils';
import { POSTER } from './constants';

import style from './style.module.scss';

const COPY_PREFIX = 'assets_sharing.footer';

const Footer = () => {
    const { locale } = getContext();
    const storeContext = useContext(AppContext);

    const [ref] = useImpressionItem({
        sendImpressionToBQ: false,
        onImpression: () => {
            reportFooterShown(storeContext);
        },
    });

    const source = [
        {
            src: getLocalizedHowFiverrWorksVideo(locale),
            type: 'video/mp4',
        },
    ];

    const onPlay = () => {
        reportFooterPlayed(storeContext, { isPlaying: true });
    };

    const onPause = () => {
        reportFooterPlayed(storeContext, { isPlaying: false });
    };

    return (
        <div className={classNames('bg-co-green-1200', style.footer)} ref={ref}>
            <Section>
                <Grid className={classNames('m-t-16', style.grid)}>
                    <Col sm={12} md={10}>
                        <div className={style.header}>
                            <h1 className={classNames('co-white', style.title)}>
                                {translate(`${COPY_PREFIX}.title`, {
                                    templates: {
                                        highlight: (text) => (
                                            <i className="font-domaine" style={{ color: lime_700 }}>
                                                {text}
                                            </i>
                                        ),
                                    },
                                })}
                            </h1>
                            <Video
                                source={source}
                                poster={POSTER}
                                className={style.video}
                                onPlay={onPlay}
                                onPause={onPause}
                            />
                        </div>
                    </Col>
                    <Col sm={12} md={10}>
                        <hr className={classNames('co-white', style.border)} />
                        <div className={style.body}>
                            <div className={style.descriptionCol}>
                                <CategoriesIcon size={24} color={lime_700} />
                                <p className={'co-white tbody-4 text-bold'}>
                                    {translate(`${COPY_PREFIX}.body.categories.title`)}
                                </p>
                                <p className={'co-grey-100'}>{translate(`${COPY_PREFIX}.body.categories.body`)}</p>
                            </div>
                            <div className={style.descriptionCol}>
                                <LockIcon size={24} color={lime_700} />
                                <p className={'co-white tbody-4 text-bold'}>
                                    {translate(`${COPY_PREFIX}.body.payment_protection.title`)}
                                </p>
                                <p className={'co-grey-100'}>
                                    {translate(`${COPY_PREFIX}.body.payment_protection.body`)}
                                </p>
                            </div>
                            <div className={style.descriptionCol}>
                                <ClockIcon size={24} color={lime_700} />
                                <p className={'co-white tbody-4 text-bold'}>
                                    {translate(`${COPY_PREFIX}.body.on_time_on_budget.title`)}
                                </p>
                                <p className={'co-grey-100'}>
                                    {translate(`${COPY_PREFIX}.body.on_time_on_budget.body`)}
                                </p>
                            </div>
                        </div>
                    </Col>
                </Grid>
            </Section>
        </div>
    );
};

export default Footer;
